__turbopack_context__.v({
  "moon": "DarkModeToggler-module-scss-module__LB3Blq__moon",
  "sun": "DarkModeToggler-module-scss-module__LB3Blq__sun",
  "toggler": "DarkModeToggler-module-scss-module__LB3Blq__toggler",
});
